// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WaveWrapper_wrapper__VsrFm","wave":"WaveWrapper_wave__SROXO"};